import { useMutation, useQueryClient } from 'react-query';
import setCompanyBranding from 'resources/company/workflows/setCompanyBranding';

const useSetCompanyBranding = () => {
  const queryClient = useQueryClient();

  return useMutation(
    'set-company-branding',
    ({ company, imageFile, bgcColor }) => setCompanyBranding({ company, imageFile, bgcColor }),
    { onSuccess: () => { queryClient.invalidateQueries('company.currentCompany'); } },
  );
};

export default useSetCompanyBranding;
